import {toast} from "react-toastify"
import {errorParser} from "../../../anwendungskonfigurator/misc/utils"
import TomClient from "../../../anwendungskonfigurator/services/tomClient"
import {pathBuilder} from "../../../anwendungskonfigurator/misc/utils"

const navigationPaths = Object.freeze({
    RISIKOORTE: "/tarifierung/:id/risikoort",
})

const bereichVersicherumsumfangArtGeneralPath =
    "/bereich/abweichung/einzelgefahrList/[i]/versicherungsumfangArt"

const handleVersicherungssummeResponse = (
    versicherungssummeResponse,
    updateData,
) => {
    const versicherungssummegebaeude = versicherungssummeResponse["_data"].find(
        (entry) => entry.versichertesRisiko === "GEBAEUDE",
    )
    const versicherungssummeinhalt = versicherungssummeResponse["_data"].find(
        (entry) => entry.versichertesRisiko === "BETRIEBSEINRICHTUNG",
    )
    if (_.isObject(versicherungssummegebaeude)) {
        updateData(
            versicherungssummegebaeude,
            `/bereich/versicherungssummegebaeude`,
        )
    }
    if (_.isObject(versicherungssummeinhalt)) {
        updateData(
            versicherungssummeinhalt,
            `/bereich/versicherungssummeinhalt`,
        )
    }
}

export const BereicheActions = ({
    getDataFromPointer,
    updateData,
    navigate,
    selectDialogContainer,
    openDialog,
    closeDialog,
    setToDefault,
    sendDataToBackend,
    loadCurrentLocationData,
    getDataFromBackend,
}) => {
    const toggleAll = (key, index, value) => {
        const currentPath = bereichVersicherumsumfangArtGeneralPath.replace(
            "[i]",
            index,
        )
        const currentValue = getDataFromPointer(currentPath)
        if (value && !currentValue.includes(key)) {
            updateData([...currentValue, key], currentPath)
        } else if (!value && currentValue.includes(key)) {
            updateData(
                currentValue.filter((entry) => entry !== key),
                currentPath,
            )
        }
    }

    const selectBereich = (risikoort, bereich) => {
        updateData(bereich, "/bereich")
        updateData(risikoort, "/risikoorte/risikoort")
        Promise.all([
            getDataFromBackend(
                bereich._links.abweichungVersicherungsumfangLoad,
                "/bereich/abweichung",
            ),
            getDataFromBackend(
                bereich._links.abweichungBetriebsartLoad,
                "/betriebsart/list",
            ),
            TomClient.callHallink(
                bereich._links.versicherungssummeLoad,
            ).then((versicherungssummeResponse) => {
                handleVersicherungssummeResponse(
                    versicherungssummeResponse,
                    updateData,
                )
            }),
        ])
    }

    const selectBereichToDefaultFromResponse = (bereicheResponse) =>
        selectBereich(
            bereicheResponse._data[0].risikoort,
            bereicheResponse._data[0].bereichList[0],
        )

    const saveCalls = () => [
        TomClient.callHallink(
            getDataFromPointer("/bereich/_links/bereichUpdate"),
            getDataFromPointer("/bereich"),
        ),
        TomClient.callHallink(
            getDataFromPointer(
                "/bereich/versicherungssummegebaeude/_links/versicherungssummeBereichUpdate",
            ),
            getDataFromPointer("/bereich/versicherungssummegebaeude"),
        ),
        TomClient.callHallink(
            getDataFromPointer(
                "/bereich/versicherungssummeinhalt/_links/versicherungssummeBereichUpdate",
            ),
            getDataFromPointer("/bereich/versicherungssummeinhalt"),
        ),
        sendDataToBackend(
            getDataFromPointer(
                "/bereich/abweichung/_links/abweichungVersicherungsumfang:update",
            ),
            getDataFromPointer("/bereich/abweichung"),
        ),
    ]

    return {
        INIT_BEREICHE: () => {
            loadCurrentLocationData("/bereiche").then(
                selectBereichToDefaultFromResponse,
            )
        },
        BACK_TO_RISIKOORT: () => {
            navigate(navigationPaths.RISIKOORTE)
        },
        WEITER_KALKULATION: () => {
            Promise.all(saveCalls()).then(() => {
                toast.success("Bereich gespeichert")
                navigate(pathBuilder(getDataFromPointer("/links/page:forward")))
            }, errorParser(updateData, "bereich"))
        },
        SELECT_BEREICH: ({risikoort, bereich}) =>
            selectBereich(risikoort, bereich),
        TOGGLE_ALL_GEBAUDE_BEREICH: ({value}) => {
            const einzelgefahrenList = getDataFromPointer(
                "/bereich/abweichung/einzelgefahrList",
            )

            einzelgefahrenList.map((gefahr, index) =>
                toggleAll("GEBAEUDE", index, value),
            )
        },
        TOGGLE_ALL_INHALT_BEREICH: ({value}) => {
            const einzelgefahrenList = getDataFromPointer(
                "/bereich/abweichung/einzelgefahrList",
            )

            einzelgefahrenList.map((gefahr, index) =>
                toggleAll("INHALT", index, value),
            )
        },
        SAVE_BEREICH: () => {
            Promise.all(saveCalls()).then(() => {
                toast.success("Bereich gespeichert")
            }, errorParser(updateData, "bereich"))
        },
        DELETE_BEREICH: (bereich) => {
            TomClient.callHallink(bereich._links.bereichDelete).then(() =>
                loadCurrentLocationData("/bereiche").then(
                    (bereicheResponse) => {
                        if (
                            bereich.modelId ===
                            getDataFromPointer("/bereich/modelId")
                        ) {
                            selectBereichToDefaultFromResponse(bereicheResponse)
                        }
                    },
                ),
            )
        },
        CREATE_BEREICH: () => {
            TomClient.callHallink(
                getDataFromPointer(
                    "/risikoorte/risikoort/_links/createBereich",
                ),
            ).then(() => loadCurrentLocationData("/bereiche"))
        },
        OPEN_BETRIEBSARTDIALOG: () => {
            setToDefault("/betriebsart/selected")
            selectDialogContainer("Betriebsart Dialog")
            openDialog()
        },
        ABORT_BEREICH_BETRIEBSART: () => {
            closeDialog()
        },
        SAVE_BEREICH_BETRIEBSART: () => {
            const betriebsart = getDataFromPointer("/betriebsart/selected")
            TomClient.callHallink(
                getDataFromPointer(
                    betriebsart.modelId
                        ? "/betriebsart/selected/_links/abweichungBetriebsartUpdate"
                        : "/bereich/_links/abweichungBetriebsartCreate",
                ),
                betriebsart,
            )
                .then(() => {
                    return TomClient.callHallink(
                        getDataFromPointer(
                            "/bereich/_links/abweichungBetriebsartLoad",
                        ),
                    )
                })
                .then((abweichungBetriebsartLoadResponse) => {
                    updateData(
                        abweichungBetriebsartLoadResponse["_data"],
                        "/bereich/betriebsart",
                    )
                })
            closeDialog()
        },
        OPEN_BETRIEBSARTEDITDIALOG: (payload) => {
            updateData(payload, "/betriebsart/selected")
            selectDialogContainer("Betriebsart Dialog")
            openDialog()
        },
        DELETE_BETRIEBSART: (betriebsart) => {
            TomClient.callHallink(
                betriebsart["_links"].abweichungBetriebsartDelete,
            )
                .then(() => {
                    return TomClient.callHallink(
                        getDataFromPointer(
                            "/bereich/_links/abweichungBetriebsartLoad",
                        ),
                    )
                })
                .then((abweichungBetriebsartLoadResponse) => {
                    updateData(
                        abweichungBetriebsartLoadResponse["_data"],
                        "/bereich/betriebsart",
                    )
                })
        },
        TOGGLE_SCHADENSEREIGNIS: (ereignis) => {
            sendDataToBackend(
                ereignis._links.patchSchadenereignisAufwand,
                ereignis,
            )
        },
    }
}
